var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDefaultUser(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10_4)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 17.3377,
    cy: 17.4263,
    r: 16.6456,
    fill: "white",
    stroke: "#7B7B7B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3376 25.5C11.3376 23.9087 11.9698 22.3826 13.095 21.2574C14.2202 20.1321 15.7463 19.5 17.3376 19.5C18.9289 19.5 20.4551 20.1321 21.5803 21.2574C22.7055 22.3826 23.3376 23.9087 23.3376 25.5H21.8376C21.8376 24.3065 21.3635 23.1619 20.5196 22.318C19.6757 21.4741 18.5311 21 17.3376 21C16.1442 21 14.9996 21.4741 14.1557 22.318C13.3118 23.1619 12.8376 24.3065 12.8376 25.5H11.3376ZM17.3376 18.75C14.8514 18.75 12.8376 16.7362 12.8376 14.25C12.8376 11.7638 14.8514 9.75 17.3376 9.75C19.8239 9.75 21.8376 11.7638 21.8376 14.25C21.8376 16.7362 19.8239 18.75 17.3376 18.75ZM17.3376 17.25C18.9951 17.25 20.3376 15.9075 20.3376 14.25C20.3376 12.5925 18.9951 11.25 17.3376 11.25C15.6801 11.25 14.3376 12.5925 14.3376 14.25C14.3376 15.9075 15.6801 17.25 17.3376 17.25Z",
    fill: "#B5B5B5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10_4"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2913,
    height: 34.2913,
    fill: "white",
    transform: "translate(0.192017 0.280701)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultUser);
export default __webpack_public_path__ + "static/media/defaultUser.cdb48fb5675d048ee40f25dd1a8ab427.svg";
export { ForwardRef as ReactComponent };